import React from 'react';
import { MapPinIcon, CalendarIcon } from 'lucide-react';
export function Header() {
  return <header className="bg-pulse-navy" data-id="element-174">
      {/* Utility Bar */}
      <div className="border-b border-white/10" data-id="element-175">
        <div className="max-w-7xl mx-auto px-4 py-2 flex items-center justify-between" data-id="element-176">
          <div className="flex items-center gap-6" data-id="element-177">
            <div className="flex items-center gap-2 text-white/80 text-sm" data-id="element-178">
              <MapPinIcon className="h-4 w-4 text-pulse-blue" aria-hidden="true" data-id="element-179" />
              <span data-id="element-180">Midlothian, VA</span>
            </div>

            <div className="hidden sm:flex items-center gap-2 text-white/80 text-sm" data-id="element-181">
              <CalendarIcon className="h-4 w-4 text-pulse-yellow" aria-hidden="true" data-id="element-182" />
              <span className="font-semibold text-pulse-yellow uppercase tracking-wider" data-id="element-183">
                Opening 2027
              </span>
            </div>
          </div>

          <div className="flex items-center gap-3" data-id="element-184">
            <a href="#signup" className="bg-pulse-orange text-white px-4 py-2 rounded-full text-sm font-bold uppercase tracking-wide hover:bg-orange-500 transition-colors" data-id="element-185">
              Join Waitlist
            </a>
            <a href="#signup" className="bg-pulse-yellow text-pulse-navy px-4 py-2 rounded-full text-sm font-bold uppercase tracking-wide hover:bg-yellow-300 transition-colors" data-id="element-186">
              Get Notified
            </a>
          </div>
        </div>
      </div>

      {/* Brand Logo Area */}
      <div className="py-6 md:py-8" data-id="element-187">
        <div className="max-w-7xl mx-auto px-4 text-center" data-id="element-188">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-black text-white tracking-tight" data-id="element-189">
            PULSE
          </h1>
          <p className="text-lg md:text-xl font-semibold text-white/90 tracking-[0.3em] uppercase mt-1" data-id="element-190">
            Entertainment Center
          </p>
          <div className="mt-4 h-1 w-48 mx-auto rounded-full bg-gradient-to-r from-pulse-blue via-pulse-yellow to-pulse-orange" data-id="element-191" />
        </div>
      </div>
    </header>;
}